import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import dayjs from 'dayjs';
import createRef from '@roo/create-react-ref/createRef';
import { polyfill } from 'react-lifecycles-compat';
import classnames from 'classnames';
import TimeCell from './TimeCell';
import { generateTime } from './utils';
var hourOptions = generateTime(23);
var minOptions = generateTime(59);
var secOptions = generateTime(59);

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker() {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.apply(this, arguments);
    _this.timePickerNode = createRef();
    _this.state = {
      time: _this.props.value || _this.props.defaultValue
    };

    _this.selectTime = function (timestamp, type, evt) {
      evt.stopPropagation();

      if (_this.props.disabledTime(timestamp, type)) {
        return;
      }

      _this.props.onChange(timestamp, type, evt);
    };

    _this.panelShowStyle = function (type) {
      var formatArr = _this.props.format.split(':');

      var formatList = formatArr.map(function (item) {
        return item.toLocaleLowerCase();
      });
      return {
        display: formatList.includes(type) ? 'inline-block' : 'none'
      };
    };

    return _this;
  }

  _createClass(TimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var timeRef = this.props.timeRef;
      var nodes = timeRef || this.timePickerNode;
      var timePicker = nodes.current;
      var activeList = timePicker && timePicker.querySelectorAll('li.active') || [];
      var ulList = timePicker && timePicker.querySelectorAll('ul') || [];
      [].forEach.call(activeList, function (node, index) {
        var _ot = node.offsetTop;
        ulList[index].scrollTo(0, _ot);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var time = this.state.time;
      var _this$props = this.props,
          timeRef = _this$props.timeRef,
          className = _this$props.className,
          disabledTime = _this$props.disabledTime;
      var hour = time.hour();
      var min = time.minute();
      var sec = time.second();
      return /*#__PURE__*/React.createElement("div", {
        className: "picker-select-wrap ".concat(className),
        ref: timeRef || this.timePickerNode
      }, /*#__PURE__*/React.createElement("ul", {
        style: this.panelShowStyle('hh')
      }, hourOptions.map(function (h) {
        var curClassName = classnames({
          active: _parseInt(h, 10) === hour,
          disabled: disabledTime(_parseInt(h, 10), 'hour')
        });
        return /*#__PURE__*/React.createElement(TimeCell, {
          key: "hour-".concat(h),
          onSelectTime: _this2.selectTime,
          time: h,
          type: "hour",
          className: curClassName
        });
      })), /*#__PURE__*/React.createElement("ul", {
        style: this.panelShowStyle('mm')
      }, minOptions.map(function (m) {
        var curClassName = classnames({
          active: _parseInt(m, 10) === min,
          disabled: disabledTime(_parseInt(m, 10), 'minute')
        });
        return /*#__PURE__*/React.createElement(TimeCell, {
          key: "min-".concat(m),
          onSelectTime: _this2.selectTime,
          time: m,
          type: "minute",
          className: curClassName
        });
      })), /*#__PURE__*/React.createElement("ul", {
        style: this.panelShowStyle('ss')
      }, secOptions.map(function (s) {
        var curClassName = classnames({
          active: _parseInt(s, 10) === sec,
          disabled: disabledTime(_parseInt(s, 10), 'second')
        });
        return /*#__PURE__*/React.createElement(TimeCell, {
          key: "sec-".concat(s),
          onSelectTime: _this2.selectTime,
          time: s,
          type: "second",
          className: curClassName
        });
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.value.format('HH:mm:ss') !== state.time.format('HH:mm:ss')) {
        return {
          time: nextProps.value
        };
      }

      return {};
    }
  }]);

  return TimePicker;
}(React.Component);

TimePicker.defaultProps = {
  timeRef: null,
  defaultValue: dayjs(),
  value: dayjs(),
  format: 'HH:mm:ss',
  className: '',
  disabled: false,
  disabledDate: false,
  onChange: function onChange() {},
  disabledTime: function disabledTime() {
    return false;
  }
};
TimePicker.propTypes = {
  defaultValue: PropTypes.object,
  timeRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  value: PropTypes.object,
  format: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledDate: PropTypes.bool,
  onChange: PropTypes.func,
  disabledTime: PropTypes.func
};
polyfill(TimePicker);
export default TimePicker;